import {get, post, put, delete_} from 'common/utils/http';

const alertActions = 'api/v1/alert-actions';

export const fetchAllActions = () => get(`${alertActions}/all`);
export const fetchAlertActionsByIds = ({payload}) => get(`${alertActions}?actionIds=${payload.join(',')}`);
export const createAlertAction = ({payload}) => post(alertActions, payload);
export const updateAlertAction = ({payload}) => put(alertActions, payload);
export const deleteAction = ({payload}) => delete_(alertActions, payload);
